import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SubmitButton from '../../../components/form/formComponents/SubmitButton';
import MODES from '../../../components/form/onSubmitModes';
import i18n from '../../../../shared/locales/no.json';

const ACTIVE_STATUS = 'ACTIVE';

class PublishButton extends Component {
    static propTypes = {
        hasErrors: PropTypes.bool,
        isSaving: PropTypes.bool,
        onRequestPublish: PropTypes.func.isRequired,
        status: PropTypes.string.isRequired,
    };

    profileIsPublished() {
        return this.props.status === ACTIVE_STATUS;
    }

    render() {
        if (this.profileIsPublished()) {
            return null;
        }

        let buttonMode;
        if (this.props.hasErrors) {
            buttonMode = MODES.DISABLED;
        } else if (this.props.isSaving) {
            buttonMode = MODES.SAVING;
        } else {
            buttonMode = MODES.EDIT;
        }

        return (
            <form
                className="u-display-inline"
                onSubmit={this.props.onRequestPublish}
            >
                <SubmitButton
                    className="button--cta u-ml16"
                    mode={buttonMode}
                    value={
                        this.props.isSaving
                            ? i18n['Is publishing']
                            : i18n['Request Publish']
                    }
                />
            </form>
        );
    }
}

export default PublishButton;
